import React, {PureComponent} from "react"
import {FormattedMessage} from "@irati/utils/lang"
import {User} from "@irati/types"

interface Props {
  user: User
}

class Greeting extends PureComponent<Props> {
  getGreeting = () => {
    const date = new Date()
    const hour = date.getHours()

    if (hour < 12) {
      return "platform.greeting.morning"
    }
    if (hour < 17) {
      return "platform.greeting.afternoon"
    }

    return "platform.greeting.evening"
  }

  render() {
    const {user} = this.props
    const firstname = user.firstName || user.firstname
    return (
      <FormattedMessage // eslint-disable-line
        id={this.getGreeting()}
        values={{firstname}} />
    )
  }
}

export default Greeting
